var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewChildren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23,
    fill: "white",
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2993 17.0993C20.2993 18.811 18.9116 20.1985 17.2 20.1985C15.4883 20.1985 14.1006 18.811 14.1006 17.0993C14.1006 15.3875 15.4883 14 17.2 14C18.9116 14 20.2993 15.3875 20.2993 17.0993Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0005 20.4333C36.439 19.9948 36.439 19.3807 36.0005 18.9422C35.562 18.5037 34.9479 18.5037 34.5094 18.9422L31.7609 21.6906H26.6733L23.9248 18.9422C23.4863 18.5037 22.8722 18.5037 22.4337 18.9422L19.6561 21.6906H14.5685L11.82 18.9422C11.3815 18.5037 10.7674 18.5037 10.3289 18.9422C9.89038 19.3807 9.89038 19.9947 10.3289 20.4333L14.2762 24.3806V32.9476C14.2762 33.5031 14.7732 34.0001 15.3288 34.0001C15.8844 34.0001 16.3814 33.5031 16.3814 32.9476V29.7604C16.3814 29.3219 16.6739 29.0586 17.0832 29.0586C17.5217 29.0586 17.785 29.3511 17.785 29.7604V32.9476C17.785 33.5031 18.282 34.0001 18.8375 34.0001C19.3931 34.0001 19.8901 33.5031 19.8901 32.9476V28.2107L19.8899 24.322L23.1354 21.2227L26.3809 24.3805L24.2466 30.9592H26.3809V32.9473C26.3809 33.5029 26.878 33.9999 27.4335 33.9999C27.9891 33.9999 28.4861 33.5029 28.4861 32.9473V30.9592H29.8895V32.9473C29.8895 33.5029 30.3866 33.9999 30.9421 33.9999C31.4977 33.9999 31.9947 33.5029 31.9947 32.9473V30.9592H34.1291L31.9947 24.3805L36.0005 20.4333Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3159 17.0993C32.3159 18.811 30.9282 20.1985 29.2166 20.1985C27.5049 20.1985 26.1172 18.811 26.1172 17.0993C26.1172 15.3875 27.5049 14 29.2166 14C30.9282 14 32.3159 15.3875 32.3159 17.0993Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChildren);
export default __webpack_public_path__ + "static/media/newChildren.1ad07f435641e49c45138e4c2fde485b.svg";
export { ForwardRef as ReactComponent };